var Search = {
  translations: undefined,

  getTranslation: function (keyword, lang) {
    if (!Search.translations[keyword])
      return keyword;
    var translations = Search.translations[keyword];
    if (!translations[lang])
      return translations["et"];
    else
      return translations[lang];
  },

  iSearch: undefined,
  pSearch: undefined,

  init: function (applicationId, applicationKey, centerId, partnerId, centerSlug, partnerSlug, partnerName, initialSearchString, centers, language, translations) {

    var body = $('body');
    var searchBar = $('.search-bar');
    if (searchBar.length === 0) return;

    var returnUrl = location.href;
    var partnerTemplate = $('#partner-search-result').html();
    var postTemplate = $('#post-search-result').html();
    var aisSearchInput;
    var latestQuery;

    Search.translations = translations;

    Search.pSearch = instantsearch({
      searchClient: algoliasearch(applicationId, applicationKey),
      indexName: 'partners',
      searchFunction: function (helper) {
        if (!!helper.state.query && helper.state.query.length > 2) {
          helper.search();
          $('#searchValuePartners').text(helper.state.query);
        }
      },
      searchParameters: {
        facets: ['centerIds', 'categories']
      }
    });
    Search.pSearch.on('render', () => {
      updatePartnerLogoBackgrounds();
    });
    Search.iSearch = instantsearch({
      searchClient: algoliasearch(applicationId, applicationKey),
      indexName: 'posts',
      routing: /*true,*/{
        router: instantsearch.routers.history({
          writeDelay: 400,
          createURL({ qsModule, routeState, location }) {
            if (!routeState.query) return location.href.split('search')[0];
            const urlParts = location.href.match(/^(.*?)\/search\//);
            const baseUrl = `${urlParts ? urlParts[1] : ''}/`;
            return `${baseUrl}search/?${$.param(routeState)}`;
          }/*,
          parseURL({ qsModule, location }) {
            const { query = '' } = qsModule.parse(
              location.search.slice(1)
            );
            return { query };
          }*/
        })/*,
        stateMapping: {
          stateToRoute(uiState) {
            return {
              query: uiState.query
            };
          },
          routeToState(routeState) {
            return {
              query: routeState.query
            };
          }
        }*/
      },
      searchFunction: function (helper) {
        if (!!helper.state.query && helper.state.query.length > 2) {
          searchBar.addClass('has-text-entered');
          latestQuery = helper.state.query;
          helper.search();
          Search.pSearch.helper.setQuery(
            Search.iSearch.helper.state.query
          );
          Search.pSearch.helper.search();
          body.addClass('search-results-open');
          $('#searchValuePosts').text(helper.state.query);
          logSearch()
        } else {
          hideSearchResults();
        }
      },
      searchParameters: {
        // facets: ['partnerName', 'centerIds', 'categories'],
        restrictSearchableAttributes: "ean,titles." + language + ",contents." + language + ",brand,categories,partnerName"
      }
    });

    // results widgets
    Search.pSearch.addWidget(instantsearch.widgets.hits({
      container: "#partnerResults .results",
      templates: {
        item: function (data) {
          return iRender(data, partnerTemplate);
        },
        empty: function (data) {
          return Search.getTranslation('search.noresults', 'et')
        }
      }
    }));

    Search.iSearch.addWidget(instantsearch.widgets.hits({
      container: "#postResults .results",
      templates: {
        item: function (data) {
          return iRender(data, postTemplate);
        },
        empty: function (data) {
          return Search.getTranslation('search.noresults', 'et')
        },
        render: function () {
          updatePSearch();
        }
      }
    }));

    // refinement widgets
    function hasAnyRefinables(options, refinementName) {
      var result = false;
      for (var refinement in options.results.disjunctiveFacets) {
        if (
          options.results.disjunctiveFacets[refinement].name === refinementName &&
          Object.keys(options.results.disjunctiveFacets[refinement].data).length > 0
        ) {
          result = true;
          break
        }
      }
      return result
    }

    const partnerRefinementList = instantsearch.widgets.panel({
      hidden(options) {
        return !('partnerName' in options.state.facetsRefinements || hasAnyRefinables(options, 'partnerName'));
      },
      templates: {
        header: Search.getTranslation('search.partners', 'et')
      }
    })(instantsearch.widgets.refinementList);

    Search.iSearch.addWidget(partnerRefinementList({
      container: '#partnerBar .partnerResults',
      attribute: 'partnerName',
      operator: 'or',
      limit: 10,
      sortBy: ["isRefined", "count:desc", "name:asc"]
    }));

    const centerRefinementList = instantsearch.widgets.panel({
      hidden(options) {
        return !('centerIds' in options.state.facetsRefinements || hasAnyRefinables(options, 'centerIds'));
      },
      templates: {
        header: Search.getTranslation('search.centers', 'et')
      }
    })(instantsearch.widgets.refinementList);

    Search.iSearch.addWidget(centerRefinementList({
      container: '#centerBar .centerResults',
      attribute: 'centerIds',
      operator: 'or',
      limit: 10,
      sortBy: ["isRefined", "count:desc", "name:asc"],
      transformItems: function (items) {
        items.map(function (item) {
          item.highlighted = centers[item.value - 1];
          return item;
        });
        return items;
      }
    }));

    const categoryRefinementList = instantsearch.widgets.panel({
      hidden(options) {
        return !('translatedCategories.' + language in options.state.disjunctiveFacetsRefinements || hasAnyRefinables(options, 'translatedCategories.' + language));
      },
      templates: {
        header: Search.getTranslation('search.categories', 'et')
      }
    })(instantsearch.widgets.refinementList);

    Search.iSearch.addWidget(categoryRefinementList({
      container: '#categoryBar .categoryResults',
      attribute: 'translatedCategories.' + language,
      operator: 'or',
      limit: 10,
      templates: {
        showMoreText:
          "{{#isShowingMore}}" + Search.getTranslation('search.refinements.less', 'et') +
          "{{/isShowingMore}}" +
          "{{^isShowingMore}}" + Search.getTranslation('search.refinements.more.categories', 'et') +
          "{{/isShowingMore}}"
      },
      showMore: true,
      sortBy: ["isRefined", "count:desc", "name:asc"]
    }));

    const brandRefinementList = instantsearch.widgets.panel({
      hidden(options) {
        return !('brand' in options.state.disjunctiveFacetsRefinements || hasAnyRefinables(options, 'brand'));
      },
      templates: {
        header: Search.getTranslation('search.brands', 'et')
      }
    })(instantsearch.widgets.refinementList);

    Search.iSearch.addWidget(brandRefinementList({
      container: '#brandBar .brandResults',
      attribute: 'brand',
      operator: 'or',
      limit: 10,
      templates: {
        showMoreText:
          "{{#isShowingMore}}" + Search.getTranslation('search.refinements.less', 'et') +
          "{{/isShowingMore}}" +
          "{{^isShowingMore}}" + Search.getTranslation('search.refinements.more.brands', 'et') +
          "{{/isShowingMore}}"
      },
      showMore: true,
      sortBy: ["isRefined", "count:desc", "name:asc"]
    }));

    const priceRefinement = instantsearch.widgets.panel({
    hidden(options) {
      return options.results.nbHits === 0 && !('finalPrice' in options.state.numericRefinements);
    },
      templates: {
        header: Search.getTranslation('search.price', 'et')
      }
    })(instantsearch.widgets.rangeInput);

    Search.iSearch.addWidget(priceRefinement({
      container: '#priceBar .priceResults',
      attribute: 'finalPrice',
      templates: {
        separatorText: Search.getTranslation('search.price.separator', 'et'),
        submitText: Search.getTranslation('search.price.submit', 'et')
      }
    }));

    const colorRefinementList = instantsearch.widgets.panel({
      hidden(options) {
        return !('translatedColors.' + language in options.state.disjunctiveFacetsRefinements || hasAnyRefinables(options, 'translatedColors.' + language));
      },
      templates: {
        header: Search.getTranslation('search.color', 'et')
      }
    })(instantsearch.widgets.refinementList);

    Search.iSearch.addWidget(colorRefinementList({
      container: '#colorBar .colorResults',
      attribute: 'translatedColors.' + language,
      operator: 'or',
      limit: 10,
      templates: {
        showMoreText:
          "{{#isShowingMore}}" + Search.getTranslation('search.refinements.less', 'et') +
          "{{/isShowingMore}}" +
          "{{^isShowingMore}}" + Search.getTranslation('search.refinements.more.colors', 'et') +
          "{{/isShowingMore}}"
      },
      showMore: true,
      sortBy: ["isRefined", "count:desc", "name:asc"]
    }));

    const sizeRefinementList = instantsearch.widgets.panel({
      hidden(options) {
        return !('size' in options.state.disjunctiveFacetsRefinements || hasAnyRefinables(options, 'size'));
      },
      templates: {
        header: Search.getTranslation('search.size', 'et')
      }
    })(instantsearch.widgets.refinementList);

    Search.iSearch.addWidget(sizeRefinementList({
      container: '#sizeBar .sizeResults',
      attribute: 'size',
      operator: 'or',
      limit: 10,
      templates: {
        showMoreText:
          "{{#isShowingMore}}" + Search.getTranslation('search.refinements.less', 'et') +
          "{{/isShowingMore}}" +
          "{{^isShowingMore}}" + Search.getTranslation('search.refinements.more.sizes', 'et') +
          "{{/isShowingMore}}"
      },
      showMore: true,
      sortBy: ["isRefined", "count:desc", "name:asc"]
    }));

    // widget conf
    Search.pSearch.addWidget(instantsearch.widgets.configure({
      hitsPerPage: 7
    }));

    Search.iSearch.addWidget(instantsearch.widgets.clearRefinements({
      container: '.search-filters-clear',
      templates: {
        resetLabel() {
          return Search.getTranslation('search.clearFilters', 'et');
        }
      },
      cssClasses: {
        link: 'btn btn-outline-primary'
      }
    }));

    Search.iSearch.addWidget(instantsearch.widgets.pagination({
      container: '#paginationContainer',
      scrollTo: '#postResults'
    }));

    Search.iSearch.addWidget(instantsearch.widgets.sortBy({
      container: '.sortBySelector',
      items: [
        {value: 'posts', label: Search.getTranslation('search.sorting', 'et')},
        {value: 'price_asc', label: Search.getTranslation('search.sorting.asc', 'et')},
        {value: 'price_desc', label: Search.getTranslation('search.sorting.desc', 'et')}
      ]
    }));

    Search.iSearch.addWidget({
      init: function (options) {refineWithPathVariables(options)},
      render: function () {
        updatePSearch();
      }
    });

    Search.iSearch.addWidget(instantsearch.widgets.searchBox({
        container: '#algolia-searchbox-container',
        searchAsYouType: true,
        placeholder: $('#algolia-searchbox-container').data('placeholder')
      })
    );

    // methods
    $('.close-search').on('click', function() {
      hideSearchResults();
    });

    $('.last-searches-item').on('click', function () {
      Search.iSearch.helper.setQuery($(this).data('value'));
      Search.iSearch.helper.search();
    });

    function updatePSearch() {
      Search.pSearch.helper.clearRefinements().search();
      var filters = Search.iSearch.helper.getQuery().facetFilters;
      if (filters) {
        filters.flat().forEach(function (flt) {
          var filter = flt.split(":");
          if (filter[0] == 'centerIds' || filter[0] == 'categories') {
            Search.pSearch.helper.toggleFacetRefinement(filter[0], filter[1]).search();
          }
        });
        $('.search-filter-enabled-indicator').addClass('show');
      } else {
        $('.search-filter-enabled-indicator').removeClass('show');
      }
    }

    function updatePartnerLogoBackgrounds(){
      $('.partner-results .card-partner').each(function () {
        var parentElement = $(this);
        if(parentElement.find(".card-logo").css("background-image") != null){
          var img = parentElement.find(".card-logo").css("background-image").replace(/^url\(['"](.+)['"]\)/, '$1');
          RGBaster.colors(img, {
            paletteSize: 10,
            exclude: ['rgb(0,0,0)'],
            success: function(payload) {
              if (payload.dominant == 'rgb(255,255,255)' && payload.secondary == 'rgb(0,0,0)') {
                parentElement.addClass('white-logo');
              }
            }
          });
        }
      });
    }

    function startISearch() {
      if (!Search.iSearch.helper) {
        Search.pSearch.start();
        Search.iSearch.start();
        aisSearchInput = searchBar.find('.ais-SearchBox-input');
        aisSearchInput.focusout(handleFocusOut);

        aisSearchInput.focus(function (e) {
          body.addClass('search-focused');
          var searchResultsOpen = body.hasClass('search-results-open');
          if (!searchResultsOpen) {
            $('#last-searches').show();
          }
        });

        aisSearchInput.on('change', function () {
          setTimeout(function () {
            $('#last-searches').hide();
          }, 200);
        });

        $('.ais-SearchBox-reset').on('click', function () {
          if (body.hasClass('area-search')) exitSearch();
          else {
            resetSearch();
            Search.iSearch.helper.clearRefinements();
            refineWithPathVariables(Search.iSearch);
            hideSearchResults();
          }
        });
      }
    }

    function iRender(el, template) {
      var renderable = doT.template(template);
      el.centerSlug = centerSlug;
      return renderable(el);
    }

    function handleFocusOut(e) {
      setTimeout(function () {
        body.removeClass('search-focused');
        $('#last-searches').hide();
      }, 200);
    }

    function refineWithPathVariables(options) {
      if (!!centerId)
        options.helper.addDisjunctiveFacetRefinement('centerIds', centerId);
    }

    function hideSearchResults() {
      if (body.hasClass('search-results-open')) {
        body.removeClass('search-results-open');
        history.pushState(null, {}, returnUrl);
      }
    }

    function exitSearch() {
      location.href = location.origin;
    }

    function resetSearch() {
      aisSearchInput.val('');
      aisSearchInput.focus();
      searchBar.removeClass('has-text-entered');
    }

    var searchLogTimer;

    function logSearch() {
      clearTimeout(searchLogTimer);
      searchLogTimer = setTimeout(function () {
        var searchString = aisSearchInput.val();
        var url = '/search/log/?q=' + searchString + '&c=' + centerSlug + '&p=' + partnerSlug;
        $.get(url);
      }, 1500);
    }

    startISearch();
    return this;
  }
};